import React from 'react';

/**
 * NotificationIcon component with badge for unread count
 * Shows a green dot when there are unread notifications
 */
const NotificationIcon = ({ unreadCount = 0, className = "" }) => {
  const hasUnread = unreadCount > 0;
  
  return (
    <div className={`relative inline-flex ${className}`}>
      {/* Notification Bell Icon */}
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 25">
        <path d="M0.5 21.3766V18.9766H2.875V10.5766C2.875 8.91656 3.36979 7.44156 4.35938 6.15156C5.34896 4.86156 6.63542 4.01656 8.21875 3.61656V2.77656C8.21875 2.27656 8.39193 1.85156 8.73828 1.50156C9.08464 1.15156 9.50521 0.976562 10 0.976562C10.4948 0.976562 10.9154 1.15156 11.2617 1.50156C11.6081 1.85156 11.7812 2.27656 11.7812 2.77656V3.61656C13.3646 4.01656 14.651 4.86156 15.6406 6.15156C16.6302 7.44156 17.125 8.91656 17.125 10.5766V18.9766H19.5V21.3766H0.5ZM10 24.9766C9.34688 24.9766 8.78776 24.7416 8.32266 24.2716C7.85755 23.8016 7.625 23.2366 7.625 22.5766H12.375C12.375 23.2366 12.1424 23.8016 11.6773 24.2716C11.2122 24.7416 10.6531 24.9766 10 24.9766ZM5.25 18.9766H14.75V10.5766C14.75 9.25656 14.2849 8.12656 13.3547 7.18656C12.4245 6.24656 11.3062 5.77656 10 5.77656C8.69375 5.77656 7.57552 6.24656 6.64531 7.18656C5.7151 8.12656 5.25 9.25656 5.25 10.5766V18.9766Z" />
      </svg>
      
      {/* Green dot badge for unread notifications */}
      {hasUnread && (
        <div className="absolute -top-1 -right-1 flex items-center justify-center">
          {/* Green dot */}
          <div className="w-3 h-3 bg-green-500 rounded-full border-2 border-white dark:border-jacarta-700 shadow-sm">
          </div>
        </div>
      )}
      
      {/* Alternative: Show count badge for many notifications */}
      {unreadCount > 9 && (
        <div className="absolute -top-2 -right-2 min-w-[18px] h-[18px] bg-red-500 text-white text-xs rounded-full flex items-center justify-center border-2 border-white dark:border-jacarta-700 shadow-sm">
          <span className="text-[10px] font-bold leading-none">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        </div>
      )}
    </div>
  );
};

export default NotificationIcon;